export default __webpack_public_path__ + "static/media/2012-desktop.e1b73def.jpg";